<!-- biome-ignore-all lint/a11y/useHeadingContent: the heading text is supplied by the consumer through the slot -->
<script setup lang="ts">
  import { modalTitleClass } from './ModalTitle.css';
</script>

<template>
  <h2 :class="modalTitleClass"><slot /></h2>
</template>
